// /* eslint-disable import/no-extraneous-dependencies */
import { FormControl, FormHelperText, FormLabel } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import moment from 'moment';
import { useSnackbar } from 'notistack';
import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { getComissoesComites } from '../../../../services/usuario/ComissaoComiteService';
import Mascara from '../../../shared/form/mascaras';
import UploadFile from '../../../shared/uploadFile';
import useStyles from '../../usuarioForm/styles';
import Formatos from '../../../../helpers/formatos';
import {getTitularidades} from "../../../../services/usuario/TitularidadeService";
import {getEntidades} from "../../../../services/usuario/EntidadeService";
import {getConselhos} from "../../../../services/usuario/ConselhoService";


const ConselheiroForm = (props) => {
  const classes = useStyles();
  const { form, onChange, handleTermoPosse, handleChangeLista, children, onDeleteTermoPosse } = props;
  const [titularidades, setTitularidades] = useState([]);
  const [entidades, setEntidades] = useState([]);
  const [conselhos, setConselhos] = useState([]);
  const [comissoesComites, setComissoesComites] = useState([]);
  const {
    register, errors, clearError, setValue,
  } = useFormContext();
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    register({ name: 'idTitularidade' }, { required: 'Titularidade é obrigatório' });
    register({ name: 'idEntidade' }, { required: 'Entidade é obrigatório' });
    register({ name: 'idConselhoConselheiro' }, { required: 'Conselho é obrigatório' });
    register({ name: 'ocupacaoConselheiro' }, { required: 'Função na entidade é obrigatório' });
    register({ name: 'nomeInterlocutor' }, { });
    register({ name: 'funcaoNaEntidadeInterlocutor' }, { });
    register({ name: 'telefoneInterlocutor' }, { minLength: { value: 14, message: 'Formato inválido' } });
    register({ name: 'emailInterlocutor' }, { });
    register({ name: 'inicioDoMandato' }, { required: 'Início do madato é obrigatório' });
    register({ name: 'fimDoMandato' }, { required: 'Fim do madato é obrigatório' });

    setValue('idTitularidade', form.conselheiroPerfil.idTitularidade);
    setValue('idEntidade', form.idEntidade);
    setValue('idConselhoConselheiro', form.conselheiroPerfil.idConselho);
    setValue('ocupacaoConselheiro', form.ocupacao);
    setValue('nomeInterlocutor', form.conselheiroPerfil.nomeInterlocutor);
    setValue('funcaoNaEntidadeInterlocutor', form.conselheiroPerfil.funcaoNaEntidadeInterlocutor);
    setValue('telefoneInterlocutor', Formatos.telefone(form.conselheiroPerfil.telefoneInterlocutor));
    setValue('emailInterlocutor', form.conselheiroPerfil.emailInterlocutor);
    setValue('inicioDoMandato', form.conselheiroPerfil.inicioDoMandato);
    setValue('fimDoMandato', form.conselheiroPerfil.fimDoMandato);


    getTitularidades().then((response) => setTitularidades(response.data));
    getEntidades().then((response) => setEntidades(response.data));
    getConselhos().then((response) => setConselhos(response.data));
    getComissoesComites().then((response) => setComissoesComites(response.data));
  }, []);

  const validarDataMandato = () => {
    const { inicioDoMandato, fimDoMandato } = form;
    const dataInicio = moment(inicioDoMandato, 'DD/MM/YYYY', true);
    const dataFim = moment(fimDoMandato, 'DD/MM/YYYY', true);

    if (inicioDoMandato) {
      validarInicioMandato(dataInicio, inicioDoMandato);
    }

    if (fimDoMandato) {
      validarFimMandato(dataFim, fimDoMandato)
    }

    if ((inicioDoMandato && fimDoMandato) && (dataInicio > dataFim)) {
      enqueueSnackbar(`Início do mandato (${inicioDoMandato}) deve ser maior que o fim (${fimDoMandato})`, { variant: 'error' })
      form.conselheiroPerfil.fimDoMandato = '';
      // setForm({ ...form, 'fimDoMandato': '' });
    }

  }

  const validarInicioMandato = (dataInicio, inicioDoMandato) => {
    if (!dataInicio.isValid()) {
      enqueueSnackbar(`Inicío do mandato informado (${inicioDoMandato}) inválido`, { variant: 'error' })
      form.conselheiroPerfil.inicioDoMandato = '';
      // setForm({ ...form, 'inicioDoMandato': '' });
    }
  }

  const validarFimMandato = (dataFim, fimDoMandato) => {
    if (!dataFim.isValid()) {
      enqueueSnackbar(`Fim do mandato informado (${fimDoMandato}) inválido`, { variant: 'error' })
      form.conselheiroPerfil.fimDoMandato = '';
      // setForm({ ...form, 'fimDoMandato': '' });
    }
  }

  return (
    <>
      <Grid item xs={12} sm={6}>
        <FormControl fullWidth error={!!errors.idTitularidade}>
          <FormLabel shrink="true">Titularidade</FormLabel>
          <Select
            required
            fullWidth
            id="idTitularidade"
            name="idTitularidade"
            value={form.conselheiroPerfil.idTitularidade}
            onChange={onChange}
            variant="outlined"
            inputProps={{
              margin: 'normal'
            }}
            IconComponent={ExpandMoreIcon}
          >
            {titularidades.map((titularidade) => (
              <MenuItem
                key={titularidade.id}
                value={titularidade.id}
              >
                {titularidade.descricao}
              </MenuItem>
            ))}
          </Select>
          <FormHelperText>{errors.idTitularidade && errors.idTitularidade.message}</FormHelperText>
        </FormControl>
      </Grid>
      <Grid item xs={12} sm={6}>
        <FormControl fullWidth error={!!errors.idEntidade}>
          <FormLabel shrink="true">Entidade</FormLabel>
          <Select
            id="idEntidade"
            name="idEntidade"
            value={form.idEntidade}
            onChange={handleChangeLista}
            fullWidth
            variant="outlined"
            inputProps={{
              margin: 'normal'
            }}
            IconComponent={ExpandMoreIcon}
          >
            {entidades.map((entidade) => (
              <MenuItem
                key={entidade.id}
                value={entidade.id}
              >
                {entidade.descricao} ({entidade.sigla})
              </MenuItem>
            ))}
          </Select>
          <FormHelperText>{errors.idEntidade && errors.idEntidade.message}</FormHelperText>
        </FormControl>
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label="Função na Entidade"
          id="ocupacaoConselheiro"
          name="ocupacaoConselheiro"
          value={form.ocupacao}
          onChange={handleChangeLista}
          InputLabelProps={{ shrink: true }}
          margin="normal"
          variant="outlined"
          error={!!errors.ocupacaoConselheiro}
          helperText={errors?.ocupacaoConselheiro?.message}
        />

      </Grid>
      <Grid item xs={12} sm={6}>
        <FormControl fullWidth error={!!errors.idConselho}>
          <FormLabel shrink="true">Conselho</FormLabel>
          <Select
            fullWidth
            required
            id="idConselhoConselheiro"
            name="idConselhoConselheiro"
            value={form.conselheiroPerfil.idConselho}
            onChange={onChange}
            variant="outlined"
            inputProps={{
              margin: 'normal'
            }}
            IconComponent={ExpandMoreIcon}
          >
            {conselhos.map((conselho) => (
              <MenuItem
                key={conselho.id}
                value={conselho.id}
              >
                {conselho.descricao}
              </MenuItem>
            ))}
          </Select>
          <FormHelperText>{errors?.idConselhoConselheiro?.message}</FormHelperText>
        </FormControl>
      </Grid>
      <Grid item xs={12} sm={6}>
        <FormControl fullWidth error={!!errors.idComissaoComite}>
          <FormLabel shrink="true">Comissão/comitê</FormLabel>
          <Select
            fullWidth
            required
            id="idComissaoComite"
            name="idComissaoComite"
            value={form.conselheiroPerfil.idComissaoComite}
            onChange={onChange}
            variant="outlined"
            inputProps={{
              margin: 'normal'
            }}
            IconComponent={ExpandMoreIcon}
          >
            {comissoesComites.map((comissaoComite) => (
              <MenuItem
                key={comissaoComite.id}
                value={comissaoComite.id}
              >
                {comissaoComite.descricao}
              </MenuItem>
            ))}
          </Select>
          <FormHelperText>{errors.idComissaoComite && errors.idComissaoComite.message}</FormHelperText>
        </FormControl>
      </Grid>
      {children}
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label="Interlocutor(a)"
          id="nomeInterlocutor"
          name="nomeInterlocutor"
          value={form.conselheiroPerfil.nomeInterlocutor}
          onChange={onChange}
          InputLabelProps={{ shrink: true }}
          margin="normal"
          variant="outlined"
          error={!!errors.nomeInterlocutor}
          helperText={errors.nomeInterlocutor && errors.nomeInterlocutor.message}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          id="funcaoNaEntidadeInterlocutor"
          name="funcaoNaEntidadeInterlocutor"
          label="Função na entidade"
          value={form.conselheiroPerfil.funcaoNaEntidadeInterlocutor}
          onChange={onChange}
          InputLabelProps={{ shrink: true }}
          margin="normal"
          variant="outlined"
          error={!!errors.funcaoNaEntidadeInterlocutor}
          helperText={errors.funcaoNaEntidadeInterlocutor && errors.funcaoNaEntidadeInterlocutor.message}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label="Telefone do(a) interlocutor(a)"
          id="telefoneInterlocutor"
          name="telefoneInterlocutor"
          value={form.conselheiroPerfil.telefoneInterlocutor}
          onChange={onChange}
          InputLabelProps={{ shrink: true }}
          margin="normal"
          variant="outlined"
          error={!!errors.telefoneInterlocutor}
          helperText={errors.telefoneInterlocutor && errors.telefoneInterlocutor.message}
          InputProps={{
            inputComponent: Mascara.telefone,
          }}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label="Email do(a) interlocutor(a)"
          id="emailInterlocutor"
          name="emailInterlocutor"
          value={form.conselheiroPerfil.emailInterlocutor}
          onChange={onChange}
          InputLabelProps={{ shrink: true }}
          margin="normal"
          variant="outlined"
          error={!!errors.emailInterlocutor}
          helperText={errors.emailInterlocutor && errors.emailInterlocutor.message}
        />
      </Grid>
      <Grid item xs={12}>
        <UploadFile
          titulo="Termo de Posse"
          onUpload={handleTermoPosse}
          onDelete={onDeleteTermoPosse}
          termoPosse={{
            name: form.conselheiroPerfil.nomeTermoPosse,
            uploadDate: form.conselheiroPerfil.dataInclusao,
            type: form.conselheiroPerfil.formatoTermoPosse,
            size: form.conselheiroPerfil.tamanhoTermoPosse,
          }}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label="Início do mandato"
          id="inicioDoMandato"
          name="inicioDoMandato"
          value={form.conselheiroPerfil.inicioDoMandato}
          onChange={onChange}
          InputLabelProps={{ shrink: true }}
          margin="normal"
          variant="outlined"
          error={!!errors.inicioDoMandato}
          helperText={errors.inicioDoMandato && errors.inicioDoMandato.message}
          onBlur={validarDataMandato}
          InputProps={{
            inputComponent: Mascara.data,
          }}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label="Fim do mandato"
          id="fimDoMandato"
          name="fimDoMandato"
          value={form.conselheiroPerfil.fimDoMandato}
          onChange={onChange}
          InputLabelProps={{ shrink: true }}
          margin="normal"
          variant="outlined"
          error={!!errors.fimDoMandato}
          helperText={errors.fimDoMandato && errors.fimDoMandato.message}
          onBlur={validarDataMandato}
          InputProps={{
            inputComponent: Mascara.data,
          }}
        />
      </Grid>
    </>
  );
};

export default ConselheiroForm;
